import { Story, Meta } from '@storybook/web-components';
import { html } from 'lit-html';
import './gsmlg-dev';

// More on default export: https://storybook.js.org/docs/web-components/writing-stories/introduction#default-export
export default {
  title: '@gsmlg/logo/gsmlg-dev',
  // More on argTypes: https://storybook.js.org/docs/web-components/api/argtypes
  argTypes: {},
} as Meta;

export interface ElementProps {
  width: number;
  height: number;
}

// More on component templates: https://storybook.js.org/docs/web-components/writing-stories/introduction#using-args
const Template: Story<ElementProps> = ({ width, height }) =>
  html`<logo-gsmlg-dev width=${width} height=${height} />`;

export const Basic = Template.bind({});
// More on args: https://storybook.js.org/docs/web-components/writing-stories/args
Basic.args = {
  width: 200,
  height: 40,
};
